// This file is automatically generated by version.js

export const VERSION: { name: string, version: string, pipeline: string, sha: string, branch: string } = {
  name:     '@nh/cars-webapp',
  version:  '0.0.1',
  pipeline: 'undefined',
  branch:   'undefined',
  sha:      'undefined'
};
